import * as React from "react";

import { MarketResearchState } from "..";

const MarketResearchContext =
    React.createContext<MarketResearchState>(undefined);

interface MarketResearchProviderProps {
    children: React.ReactNode;
    state: MarketResearchState;
}

export const MarketResearchProvider = (props: MarketResearchProviderProps) => {
    const { children, state } = props;

    return (
        <MarketResearchContext.Provider value={state}>
            {children}
        </MarketResearchContext.Provider>
    );
};

export const useMarketResearchContext = () => {
    const ctx = React.useContext(MarketResearchContext);
    if (!ctx) {
        throw new Error(
            "useMarketResearchContext can only be used inside of an MarketResearchProvider component"
        );
    }
    return ctx;
};
